(function (angular) {
	'use strict';

	angular
		.module('twoFactorAuthModule')
		.controller('TwoFactorSms', [
			'$rootScope',
			'globalConfig',
			'TwoFactorAuthFactory',
			'urlFactory',
			TwoFactorSmsFunction
		]);

	function TwoFactorSmsFunction($rootScope, globalConfig, TwoFactorAuthFactory, urlFactory) {
		var twoFactorSms = this;

		twoFactorSms.verify = function(form) {
			TwoFactorAuthFactory.verifyEnrollmentCode('sms', form)
				.catch(function() {
					twoFactorSms.authCode = "";
					twoFactorSms.verificationSuccess = false;
				});
		};

		twoFactorSms.clearNewPhone = function() {
			if(twoFactorSms.phoneNumberId !== -1){
				twoFactorSms.newPhoneNumber = '';
			}
		};

		twoFactorSms.resendSmsCode = function() {
			urlFactory.postPromise('/account/security/two-factor-authentication/sms/resendcode');
		};
		
		twoFactorSms.displayErrors = function() {
			var valueArr;
			Object.keys(twoFactorSms.serverSideErrorMap).forEach(function(key) {
				valueArr = twoFactorSms.serverSideErrorMap[key];
				angular.forEach(valueArr, function(value) {
					$rootScope.ToastFactory.show({
						message: value,
						type: 'error'
					});
				});
			});
		};
		
		twoFactorSms.$onInit = function() {
			angular.extend(twoFactorSms, globalConfig);
			
			if(angular.isDefined(twoFactorSms.serverSideErrorMap)) {
				twoFactorSms.displayErrors();
			}
		};
	}
})(window.angular);